import { useEffect, type ReactNode } from 'react';

export type ConfirmModalProps = {
    title: string;
    body: ReactNode;
    confirmLabel?: string;
    altConfirmLabel?: string;
    cancelLabel?: string;
    isDestructive?: boolean;
    onConfirm: () => void;
    onAltConfirm?: () => void;
    onCancel: () => void;
};

export default function ConfirmModal({
    title, body, confirmLabel = 'Confirm', altConfirmLabel, cancelLabel = 'Cancel',
    isDestructive = false, onConfirm, onAltConfirm, onCancel,
}: ConfirmModalProps) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onCancel]);

    return (
        <div className='modal-backdrop' onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
            <div className='modal' role='dialog' aria-modal='true'>
                <h2 className='modal-title'>{title}</h2>
                <div className='modal-body'>{body}</div>
                <div className='modal-actions'>
                    <button className='user-cancel-btn' onClick={onCancel}>{cancelLabel}</button>
                    {altConfirmLabel && onAltConfirm && (
                        <button className='modal-alt-btn' onClick={onAltConfirm}>
                            {altConfirmLabel}
                        </button>
                    )}
                    <button
                        className={isDestructive ? 'batch-action-btn danger' : 'user-submit-btn'}
                        onClick={onConfirm}
                        autoFocus
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}